import { useEffect, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  loginWithEmailAndPassword,
  registerWithEmailAndPassword,
  reset,
} from "../../../redux/auth/authSlice";
import SlideComp from "../../../components/layout/Slide";

import Loader from "../../../components/Loader";
import { toast } from "react-toastify";
import Layout from "../../../components/layout/Layout";
import { Button, Dropdown } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import axios from "axios";
import countries from "countries-list";
import { blobURL } from "common/StringUtils";
import { Helmet } from "react-helmet";
import CheckboxUI from "components/CheckboxUI";
import { DiscoverInvozio } from "../DiscoverInvozio";
import { LOCALES } from "common/constants";

const CreateAccount = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const language = localStorage.getItem("i18nextLng");
  const invoicePDF = `${blobURL}/invoice.pdf`;
  const invoiceSwidishPDF = `${blobURL}/invoiceSwidish.pdf`;
  const workAgrementSwedish = `${blobURL}/Allmänt avtal för Egenanställning.pdf`;
  const workAgrementEnglish = `${blobURL}/General Contract for Self-Employment.pdf`;

  const [show, setShow] = useState({
    value: "",
    show: false,
    complete: false,
    acception: true,
    errorMessage: false,
    successMessage: false,
    completeSuccessful: false,
  });

  const [passVisible, setPassVisibile] = useState(false);
  const [DOBValue, setDOBValue] = useState("");
  const [isAmbassador, setAmbassador] = useState(false);
  const [socialPlatformId, setSocialPlatformId] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    watch,
    setValue,
    register,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm();

  const { isLoading, isError, message, userData } = useSelector(
    (state) => state.auth
  );

  const accountType = sessionStorage.getItem("accountType");

  const dateOfBirth = watch("DOB");
  const ssnNumber = watch("ssn");

  const fetchSocialPlatformId = async (platformId) => {
    try {
      const res = await axios.get(
        `adminsocialusers/data?data=${platformId}`,
        {}
      );
      if (res.data.response.isValid) {
        setSocialPlatformId(res.data.response.id);
      }
    } catch (err) {
      navigate("/error");
    }
  };

  useEffect(() => {
    sessionStorage.setItem("invitationUserId", searchParams.get("userId"));
    // setSearchParams({});
    const getisAmbassador = searchParams.get("ambassador");
    const getSocialPlatformId = searchParams.get("SocialPlatformId");
    const encoded = encodeURIComponent(getSocialPlatformId);
    if (getisAmbassador) {
      setAmbassador(getisAmbassador);
    } else {
      setAmbassador(false);
    }

    if (encoded !== "null") {
      fetchSocialPlatformId(encoded);
    }
  }, [searchParams, fetchSocialPlatformId]);

  useEffect(() => {
    if (accountType === "2") {
      setValue("lastName", "");
    }
  }, [accountType, setValue]);

  useEffect(() => {
    if (dateOfBirth) {
      setValue("ssn", "");
    } else {
      setValue("DOB", "");
    }
  }, [dateOfBirth, setValue]);

  useEffect(() => {
    return () => dispatch(reset());
  }, [dispatch]);

  // useEffect(() => {
  //   if (isSuccess) {
  //     navigate(`/thankyou/${watch("email")}`);
  //   }
  // }, [isSuccess, dispatch, navigate]);

  useEffect(() => {
    if (
      message ===
      "Request failed: Det finns ingen användare kopplad till den här anställda."
    ) {
      toast.error(t("There is no user associated with this employee."));
    } else {
      if (isError) toast.error(t(message));
    }
  }, [isError, message, t]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    trigger();
  }, [language]); 

  const newDetails = [];
  Object.keys(countries.countries).forEach((code) => {
    // if (countries.countries[code].continent === "EU") {
    newDetails.push(countries.countries[code].name);
    // }
  });
  newDetails.splice(45, 1);

  const loginUserIfRegistred = async (email, password) => {
    const response = await dispatch(
        loginWithEmailAndPassword({
          email: email,
          password: password,
        })
      );
  
    if (response?.payload === "account_deactivated") {
      settoggleReactivate(true);
    }

    if (response?.payload === "inactive_account") {
      settoggleReactivate(true);
      setInactiveAccount(true);
    }

    if (response && typeof response.payload === "object") {
      toast.success(t("Logged in successfully"));
    }
  }
  const onSubmit = async (values) => {
    const isNotEmpty = (value) => value.trim() !== "";

    const requiredFields = [
      "firstName",
      "profession",
      "address",
      "city",
      "country",
      "postal",
    ];

    if (accountType !== "2") {
      requiredFields.push("lastName");
    }

    const areAllFieldsValid = requiredFields.every((field) =>
      isNotEmpty(values[field])
    );

    if (!areAllFieldsValid) {
      toast.error(t("Empty spaces are not permitted"));
    } else {
      if (!DOBValue && ssnNumber?.length < 12) {
        toast.error(t("SSN number must have 12 digits."));
      } else {
        if (!ssnNumber && DOBValue?.length < 11) {
          toast.error(t("DOB must have 11 digits."));
        } else {
          if (
            values.email === values.confirmEmail &&
            values.password === values.confirmPassword
          ) {
            const { DOB, ...updatedValues } = values;
            if (!DOBValue) {
              updatedValues.dateBirth = "";
              updatedValues.dateOfBirth = "";
            }
            const response = await dispatch(
              registerWithEmailAndPassword({
                ...updatedValues,
                id: 0,
                organisation: "",
                accountType: accountType || 1,
                invitedBy:
                  sessionStorage.getItem("invitationUserId") === "null"
                    ? 0
                    : sessionStorage.getItem("invitationUserId") || 0,
                dateOfBirth: DOBValue
                  ? values.ssn === ""
                    ? values?.dateBirth || ""
                    : values?.dateBirth || ""
                  : "",
                invitedByAmbassador: isAmbassador,
                socialPlatformId,
                profession: values?.profession,
                address: values?.address,
                city: values?.city,
                country: values?.country,
                zipCode: values?.postal,
                language,
              })
            );

            if (response && response.payload.statusCode === 200) {
              if (userData?.response?.userId) {
                await loginUserIfRegistred(values.email, values.password);
                // navigate(
                //   language === LOCALES.EN_US
                //     ? `/thankyou/${response?.payload?.response?.userId}?lang=${LOCALES.EN_US}`
                //     : `/tack/${response?.payload?.response?.userId}?lang=${LOCALES.SV_SE}`
                // );
              } else {
                const timeoutMilliseconds = 5000;

                const checkUserIdInterval = setInterval(() => {
                  if (response?.payload?.response?.userId) {
                    clearInterval(checkUserIdInterval);
                    loginUserIfRegistred(values.email, values.password);
                    // navigate(
                    //   language === LOCALES.EN_US
                    //     ? `/thankyou/${response?.payload?.response?.userId}?lang=${LOCALES.EN_US}`
                    //     : `/tack/${response?.payload?.response?.userId}?lang=${LOCALES.SV_SE}`
                    // );
                  }
                }, 100);

                setTimeout(() => {
                  clearInterval(checkUserIdInterval);
                }, timeoutMilliseconds);
              }
            }
          }
        }
      }
    }
  };

  return (
    <>
      {" "}
      <Layout
        className="sign-up-email new_sign_desns new_create new_sign_up new_margin_header"
        hidefooter
        headerColor="secondary"
      >
        <Helmet>
          <link rel="canonical" href="https://invozio.com/e-postregister" />
        </Helmet>
        {isLoading && <Loader />}
        <div className="logn_pge_dsgn create">
          <div className="container">
            <div className="row">
              <div className="col-md-6 remove_div">
                <DiscoverInvozio />
              </div>

              <div className="col-md-6 add_div_my">
                <div className="bg-light">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="d-flex align-items-center justify-content-between freeaccount">
                      <h1 className="mb-3 text-dark ">
                        {t("Create Free Account")}
                      </h1>
                      <Dropdown className="mb-4 drp_new_class">
                        <Dropdown.Toggle variant="primary createaccount_btn">
                          {accountType === "1"
                            ? t("For freelance & consultant")
                            : accountType === "2"
                            ? t("For Business")
                            : t("Select Your Account Type") ||
                              t("Select Your Account Type")}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            value={1}
                            onClick={(e) => {
                              navigate(
                                language === LOCALES.EN_US
                                  ? `/emailregister?lang=${LOCALES.EN_US}`
                                  : `/e-postregister?lang=${LOCALES.SV_SE}`
                              );
                              sessionStorage.setItem("accountType", 1);
                            }}
                          >
                            {t("For freelance & consultant")}
                          </Dropdown.Item>
                          <Dropdown.Item
                            defaultValue={2}
                            onClick={() => {
                              navigate(
                                language === LOCALES.EN_US
                                  ? `/emailregister?lang=${LOCALES.EN_US}`
                                  : `/e-postregister?lang=${LOCALES.SV_SE}`
                              );
                              sessionStorage.setItem("accountType", 2);
                            }}
                          >
                            {t("For Business")}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="mb-3 already-account">
                      {t("Already have an account")}?
                      <Link
                        to={
                          language === LOCALES.EN_US
                            ? `/emaillogin?lang=${LOCALES.EN_US}`
                            : `/e-postinloggning?lang=${LOCALES.SV_SE}`
                        }
                        style={{ textDecoration: "underline" }}
                      >
                        {" "}
                        {t("Sign in")}
                      </Link>
                    </div>
                    <div className="div_busnn">
                      {/* <label className="email_mns">Business Name</label> */}
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">{t("First Name")}</label>
                          <input
                            type="text"
                            className="form-control m-0"
                            placeholder={t("First Name")}
                            required
                            {...register("firstName")}
                          />
                        </div>

                        <div className="ml-2 w-100">
                          <label className="email_mns">{t("Last Name")}</label>
                          <input
                            type="text"
                            className="form-control m-0 w-100"
                            placeholder={t("Last Name")}
                            required
                            {...register("lastName")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="div_busnn">
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">{t("Email")}</label>
                          <input
                            type="text"
                            className="form-control m-0"
                            placeholder={t("Email")}
                            required
                            {...register("email", {
                              pattern: {
                                value:
                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: t("Invalid email address"),
                              },
                            })}
                          />
                        </div>
                        <div className="ml-2 w-100">
                          <label className="email_mns">
                            {t("Confirm Email")}
                          </label>
                          <input
                            type="text"
                            className="form-control m-0 w-100"
                            placeholder={t("Confirm Email")}
                            required
                            {...register("confirmEmail", {
                              pattern: {
                                value:
                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: t("Invalid email address"),
                              },
                              validate: (value) =>
                                value === watch("email") ||
                                t("The emails do not match"),
                            })}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="div_busnn">
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">
                            {t("Phone Number")}
                          </label>
                          <input
                            type="number"
                            min="0"
                            className="form-control w-100 m-0"
                            placeholder={t("Phone Number")}
                            required
                            {...register("phoneNo", {
                              pattern: {
                                value: /^\d+$/i,
                                message: "Invalid Phone Number",
                              },
                              maxLength: {
                                value: 13,
                                message: "Invalid Phone Number",
                              },
                              minLength: {
                                value: 8,
                                message: "Invalid Phone Number",
                              },
                            })}
                          />
                        </div>
                        <div className="w-100 ml-2">
                          <label className="email_mns">
                            {t("Your 12 digit SSN. No")}
                          </label>
                          <input
                            min="0"
                            readOnly={dateOfBirth}
                            className="form-control w-100 m-0"
                            placeholder={t("Your 12 digit SSN. No")}
                            onKeyDown={(e) => {
                              const inputValue = e.key;
                              const allowedCharacters =
                                /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                              if (
                                inputValue !== "Backspace" &&
                                !allowedCharacters.test(inputValue)
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onInput={(e) => {
                              const maxLength = 12;
                              e.target.value = e.target.value.replace(
                                /[^a-zA-Z0-9]/g,
                                ""
                              );

                              if (e.target.value.length > maxLength) {
                                e.target.value = e.target.value.slice(
                                  0,
                                  maxLength
                                );
                              }
                            }}
                            {...register("ssn")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="checkbox-wrapper-37 mt-3 d-flex">
                      <input
                        type="checkbox"
                        name="checkbox"
                        id="terms-checkbox-37"
                        onClick={(e) => {
                          if (!e.target.checked) {
                            setDOBValue("");
                            setShow({
                              completeSuccessful: false,
                            });
                          }
                        }}
                        disabled={ssnNumber}
                        {...register("DOB")}
                      />
                      <label
                        htmlFor="terms-checkbox-37"
                        className="terms-label mr-2"
                      >
                        <CheckboxUI />
                      </label>
                      <span className="label-text">
                        {t("Do not have SSN. No.")}
                      </span>
                    </div>
                    <div className="d-flex flex-column transparent">
                      <div className="w-100 d-flex mb-2 text-left">
                        <div className="d-flex flex-column align-items-start spn_cls mt-1">
                          {dateOfBirth && (
                            <span
                              className={`${
                                show.complete || show.completeSuccessful
                                  ? "ml-4 text-success"
                                  : show.successMessage
                                  ? "text-success"
                                  : show.errorMessage
                                  ? "text-danger"
                                  : ""
                              }`}
                            >
                              {show.complete
                                ? t("Enter at least 3 digits randomly")
                                : show.completeSuccessful
                                ? t("Successful")
                                : t(
                                    "Date of birth should be in this Format Ex- 199810290000"
                                  )}
                            </span>
                          )}
                        </div>
                      </div>
                      {dateOfBirth && (
                        <input
                          autoFocus
                          type="number"
                          className="form-control w-100 m-0 mb-3"
                          value={DOBValue}
                          placeholder={t("YYYYMMDD000")}
                          {...register("dateBirth", {
                            onChange: (e) => {
                              const index = Array.from(e.target.value)[4];
                              if (e.target.value.length <= 11) {
                                setDOBValue(e.target.value);
                              }
                              if (
                                e.target.value >= 3 &&
                                e.target.value.length === 1
                              ) {
                                setShow({
                                  ...show,
                                  errorMessage: true,
                                  complete: false,
                                  successMessage: false,
                                  completeSuccessful: false,
                                });
                              } else if (
                                e.target.value.length === 0 ||
                                (index !== undefined && !index === 1) ||
                                index === 0
                              ) {
                                setShow({
                                  ...show,
                                  errorMessage: true,
                                  successMessage: false,
                                  complete: false,
                                  completeSuccessful: false,
                                });
                              } else if (
                                (e.target.value === 1 ||
                                  e.target.value === 2 ||
                                  e.target.value.length >= 5) &&
                                e.target.value.length < 8
                              ) {
                                setShow({
                                  ...show,
                                  errorMessage: false,
                                  complete: false,
                                  successMessage: true,
                                  completeSuccessful: false,
                                  acception: true,
                                });
                              } else if (
                                e.target.value.length === 8 &&
                                show.acception
                              ) {
                                setDOBValue(e.target.value + 0 + 0 + 0);
                                setShow({
                                  ...show,
                                  errorMessage: false,
                                  successMessage: true,
                                  complete: false,
                                  completeSuccessful: true,
                                  acception: false,
                                });
                              } else if (
                                e.target.value.length >= 8 &&
                                e.target.value.length < 11
                              ) {
                                setShow({
                                  ...show,
                                  errorMessage: false,
                                  successMessage: true,
                                  complete: true,
                                  completeSuccessful: false,
                                });
                              } else if (e.target.value.length === 11) {
                                setShow({
                                  ...show,
                                  errorMessage: false,
                                  successMessage: true,
                                  complete: false,
                                  completeSuccessful: true,
                                });
                              }
                            },
                          })}
                        />
                      )}
                    </div>

                    <div className="div_busnn">
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">{t("Profession")}</label>
                          <input
                            type="text"
                            className="form-control w-100 m-0"
                            placeholder={t("Profession")}
                            required
                            {...register("profession")}
                          />
                        </div>
                        <div className="w-100 ml-2">
                          <label className="email_mns">{t("Address")}</label>
                          <input
                            className="form-control w-100 m-0"
                            placeholder={t("Address")}
                            required
                            {...register("address")}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="div_busnn">
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">{t("City")}</label>
                          <input
                            type="text"
                            className="form-control w-100 m-0"
                            placeholder={t("City")}
                            required
                            {...register("city")}
                          />
                        </div>
                        <div className="w-100 ml-2">
                          <label className="email_mns">{t("Country")}</label>
                          <select
                            className="form-control w-100 m-0"
                            required
                            {...register("country", { required: true })}
                          >
                            <option value="">{t("Select Country")}</option>
                            <option value={"Sweden"}>{"Sweden"}</option>
                            <option value={"USA"}>{"USA"}</option>
                            {newDetails.map((country, index) => (
                              <option key={index} value={country}>
                                {country}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="div_busnn">
                      <div className="d-flex mb-3">
                        <div className="w-100">
                          <label className="email_mns">
                            {t("Postal code")}
                          </label>
                          <input
                            type="number"
                            min="0"
                            className="form-control w-100 m-0"
                            placeholder={t("Postal code")}
                            required
                            {...register("postal")}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="d-flex mb-3 last">
                      <div className="w-100 change-password-icon mb-2">
                        <div>
                          <label className="email_mns">{t("Password")}</label>
                          <div className="input-group">
                            <div className="input-div">
                              <input
                                max="20"
                                type={passVisible ? "text" : "password"}
                                className="form-control mt-0 mb-0"
                                placeholder={t("Password")}
                                required
                                {...register("password", {
                                  minLength: {
                                    value: 8,
                                    message: t(
                                      "Password must be atleast 8 characters in length"
                                    ),
                                  },
                                  pattern: {
                                    value:
                                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i,
                                    message: t(
                                      "Password must have a capital letter and a number, and hyphen is also not accepted in the password"
                                    ),
                                  },
                                })}
                              />
                            </div>
                            <div className="input-group-append pr-3">
                              {passVisible ? (
                                <AiOutlineEyeInvisible
                                  className="m-auto"
                                  size={24}
                                  onClick={() => setPassVisibile(false)}
                                />
                              ) : (
                                <AiOutlineEye
                                  className="m-auto"
                                  size={24}
                                  onClick={() => setPassVisibile(true)}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="w-100 change-password-icon ml-2">
                        <div>
                          <label className="email_mns">
                            {t("Confirm Password")}
                          </label>
                        </div>
                        <div className="input-group">
                          <div className="input-div">
                            <input
                              max="20"
                              type={passVisible ? "text" : "password"}
                              className="form-control mt-0 ml-0 mb-0"
                              placeholder={t("Confirm Password")}
                              required
                              {...register("confirmPassword", {
                                minLength: {
                                  value: 8,
                                  message: t(
                                    "Password must be atleast 8 characters in length"
                                  ),
                                },
                                pattern: {
                                  value:
                                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i,
                                  message: t(
                                    "Password must have a capital letter and a number, and hyphen is also not accepted in the password"
                                  ),
                                },
                                validate: (value) =>
                                  value === watch("password") ||
                                  t("The passwords do not match"),
                              })}
                            />
                          </div>
                          <div className="input-group-append pr-3">
                            {passVisible ? (
                              <AiOutlineEyeInvisible
                                className="m-auto"
                                size={24}
                                onClick={() => setPassVisibile(false)}
                              />
                            ) : (
                              <AiOutlineEye
                                className="m-auto"
                                size={24}
                                onClick={() => setPassVisibile(true)}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`checkbox-wrapper-37 align-items-start ${
                        errors.customCheck ? "border-red" : ""
                      } mt-3 d-flex`}
                    >
                      <input
                        type="checkbox"
                        name="checkbox"
                        id="terms-checkbox-38"
                        {...register("customCheck", {
                          required: t("Please select the terms and condition"),
                        })}
                      />
                      <label
                        htmlFor="terms-checkbox-38"
                        className="terms-label mr-2"
                      >
                        <svg
                          className={`checkbox-svg ${
                            errors.customCheck ? "svg-border-red" : ""
                          }`}
                          viewBox="0 0 200 200"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask id="path-1-inside-1_476_5-37" fill="white">
                            <rect width="200" height="200" />
                          </mask>
                          <rect
                            width="200"
                            height="200"
                            className="checkbox-box"
                            strokeWidth="40"
                            mask="url(#path-1-inside-1_476_5-37)"
                          />
                          <path
                            className="checkbox-tick"
                            d="M52 111.018L76.9867 136L149 64"
                            strokeWidth="15"
                          />
                        </svg>
                      </label>
                      <span className="label-text">
                        {t(
                          "I hereby confirm that I have read, understood, and accepted the applicable "
                        )}
                        <a
                          className=" how_calculate_link"
                          href={
                            language === LOCALES.EN_US
                              ? workAgrementEnglish
                              : workAgrementSwedish
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {t("general terms and conditions as of the current date")}
                        </a>
                        , {t("including the right to work, the general fixed-term employment agreement, and the")}{" "}
                        <a
                          className=" how_calculate_link"
                          href={
                            language === LOCALES.EN_US ? invoicePDF : invoiceSwidishPDF
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {t("annex concerning the processing of personal data.")}
                        </a>
                      </span>
                    </div>
                    {Object.keys(errors).length > 0 && (
                      <div className="text-center w-100">
                        <p className="text-danger">
                        {errors[Object.keys(errors)[0]]?.message}
                        </p>
                      </div>
                    )}
                    <Button
                      variant="primary "
                      type="submit"
                      className="mt-4 text-light filled new_theme_btn mb-3"
                      size="lg"
                    >
                      {t("Create Free Account")}
                    </Button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
      <section className="new_scts trustplot_sctn new_desig_tooltip_ca pb-5">
        <div className="container container-dynamic pb-0">
          <div
            className="trustpilot-widget"
            data-locale={LOCALES.SV_SE}
            data-template-id="5406e65db0d04a09e042d5fc"
            data-businessunit-id="64f712e3dbd20bbfcf3a825f"
            data-style-height="28px"
            data-style-width="100%"
            data-theme="light"
          >
            <a
              href="https://se.trustpilot.com/review/invozio.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Trustpilot
            </a>
          </div>
        </div>
      </section>
      <div className="footer_below dashbrd_foter_below_ca">
        <SlideComp />
      </div>
    </>
  );
};
export default CreateAccount;
